import { rModelsBase } from './.catalog';

export class rOyakDegerlemeUstBilgi extends rModelsBase {
  public gm_toplam: number;
  constructor() {
    super();
    this.gm_toplam = 0;
  }
}
